<template>
  <div class="body">
    <div class="is-pay">
      <i class="icon icon-time"></i>
      <h3>待支付</h3>
      <p>剩余71时59分自动取消</p>
    </div>
    <div class="add-add">
      <i class="icon icon-add-add"></i>
      新增收货地址
    </div>
    <div class="exps">配送：京东快递、顺丰快递；</div>
    <div class="pres">
      <div class="pres-head">处方</div>
      <div class="pat-cont font-85">
        <div class="pat-item">
          <p>姓名</p>张三丰
        </div>
        <div class="pat-item">
          <p>性别</p>男
        </div>
        <div class="pat-item">
          <p>年龄</p>30岁
        </div>
        <div class="pat-item">
          <p>科别</p>肿瘤科
        </div>
      </div>
      <div class="zhenduan">
        <p>诊断：甲状腺结节，初期</p>
        <p>审方：丽丽</p>
        <p>
          支付后即可查看处方
          <span>共20味</span>
        </p>
      </div>
      <div class="docname font-85">医师：李佩文</div>
    </div>
    <div class="prices">
      <div class="price-item">
        <span>药方总价</span>
        <span>￥123</span>
      </div>
      <div class="price-item">
        <span>代煎费</span>
        <span>￥123</span>
      </div>
      <div class="price-item">
        <span>运费</span>
        <span>￥123</span>
      </div>
      <div class="price">
        <span>合计：</span>
        <span class="font-red">￥877.04</span>
      </div>
    </div>
    <div class="mask" v-if="paying"></div>
    <div class="pay-bottom">
      <div class="kefu" @click="handleCall">
        <i class="icon icon-kefu"></i>
        客服
      </div>
      <div class="pay-price">实付：877.04元</div>
      <div class="pay-btn">去支付</div>
    </div>
  </div>
</template>

<script>
import {getCustomerPhone} from '../../utils/index';
export default {
  name: "order_pay",
  data() {
    return {};
  },
  methods: {
    handleCall() {
      if (this.$cookies.get("customer_phone")) {
        window.location.href = `tel:${this.$cookies.get("customer_phone")}`;
      }else{
        getCustomerPhone(this,(phone) => {
          window.location.href = `tel:${phone}`
        });
      }
    },
  },
};
</script>

<style scoped>
.body {
  padding-top: 0;
}

.icon-time {
  content: url("../../../static/icons/To_be_paid@3x.png");
  width: 1rem;
  height: 1rem;
  margin-right: 0.6rem;
}
.is-pay h3 {
  font-size: 1rem;
  font-weight: 400;
}
.is-pay p {
  font-size: 0.6rem;
  margin-left: 0.6rem;
  line-height: 1.2rem;
}
.add-add {
  border-bottom: 0.05rem solid #f5f5f5;
  margin: 0;
}
.exps {
  width: 100%;
  height: 2.7rem;
  background: #fff;
  padding: 0 1rem;
  line-height: 2.7rem;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.65);
}
.pres {
  width: 100%;
  height: auto;
  background: #feffe6;
}
.pres-head {
  width: 100%;
  height: 2.8rem;
  text-align: center;
  font-size: 1rem;
  line-height: 2.8rem;
  border-bottom: 0.05rem solid #f5f5f5;
  font-weight: 700;
}
.pat-cont {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 2rem;
}
.pat-item {
  text-align: center;
  font-size: 16px;
}
.pat-item p {
  font-size: 0.6rem;
  color: rgba(0, 0, 0, 0.45);
}
.zhenduan {
  padding: 0 1rem;
  border-bottom: 0.05rem solid #f5f5f5;
}
.zhenduan p {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.6rem;
}
.docname {
  line-height: 3.2rem;
  font-size: 0.8rem;
  text-align: right;
  padding: 0 1rem;
}
.prices {
  padding: 1rem 1rem 0 1rem;
  background: #fff;
}
.price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.5rem;
}
.price {
  display: flex;
  justify-content: space-between;
  line-height: 3.2rem;
  font-size: 0.8rem;
  border-top: 0.05rem solid #f5f5f5;
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/wenzhen_order_content.vue